import React, { Component } from 'react';
// import PropTypes from 'prop-types';

import './CoursePlan.scss';
import Button from '../../button';
import { formatMultiLanguageText } from '../../../utils/multi-language-utils';
import { StudentCourse } from '../../../models/user';

interface CustomProps {
  course: StudentCourse;
  onSelect: (course: any) => void;
  onChangeExpanded: () => void;
  isExpanded: boolean;
  selectedId?: string;
  disableSelect: boolean;
}

interface CustomState {
  isMore: boolean;
}

class CoursePlan extends Component<CustomProps, CustomState> {
  constructor(props: CustomProps) {
    super(props);
    this.state = {
      isMore: false,
    };
  }

  renderPlanHeaderAmount() {
    return (
      <h2 className="md:text-2xl text-lg md:leading-normal font-medium md:font-semibold">
        AED{' '}
        {this.props.course.amount.totalAmount -
          this.props.course.amount.totalDiscount}
      </h2>
    );
  }

  getAmountPerClass(): number | undefined {
    if (this.props.course.courseType.isLumpSumCourse) {
      return undefined;
    }
    const stage = this.props.course.stages.find(
      (st) =>
        st.feeCodes.find((fc) =>
          this.props.course.course.amountPerClassFeeCodes.includes(fc.code)
        ) !== undefined
    );
    if (!stage) {
      return undefined;
    }

    const feeCode = stage.feeCodes.find((fc) =>
      this.props.course.course.amountPerClassFeeCodes.includes(fc.code)
    );

    if (!feeCode) {
      return undefined;
    }

    const taxableAmount = stage?.amount?.taxableAmount;
    const fullPaymentDiscount = stage?.amount?.fullPaymentDiscount ?? 0;
    const quantity = feeCode?.quantity;
    let amountPerQuantity = Math.round(taxableAmount / quantity) ?? 0;
    if(fullPaymentDiscount > 0){
      const fullPaymentDisQuantity = Math.round(fullPaymentDiscount / quantity);
      amountPerQuantity -= fullPaymentDisQuantity;
    }
    return amountPerQuantity * (stage.noOfClassesPerHour || 1);
  }

  renderLumpSumDisclaimer() {
    return (
      <p className="text-[13px] text-muted max-w-[180px] md:max-w-[300px]">
        (License Guaranteed)<sup className="text-primary">**</sup>
      </p>
    );
  }

  // eslint-disable-next-line class-methods-use-this
  renderPlanHeaderCourseTypeName(courseType: string) {
    return <span className="Plan__type">{courseType}</span>;
  }

  // eslint-disable-next-line class-methods-use-this
  renderPlanHeaderNote() {
    return (
      <p className="text-[10px] lg:text-[13px] text-muted max-w-[180px] md:max-w-[300px]">
        (5% VAT applicable on {process.env.REACT_APP_COMPANYNAME} Fees)
      </p>
    );
  }

  renderPlanHeaderSelectButton(courseType: string) {
    return (
      <div className="Plan__btn">
        <Button
          type="button"
          size="sm"
          onClick={() => {
            this.props.onSelect(this.props.course);
          }}
        >
          Choose {courseType}
        </Button>
      </div>
    );
  }

  renderPlanHeaderOriginalCourseAmount() {
    return (
      <span className="text-muted line-through">
        AED {this.props.course.amount.totalAmount}{' '}
      </span>
    );
  }

  renderPlanHeaderDiscountInfo() {
    return (
      <span className="text-primary">
        You save AED {this.props.course.amount.totalDiscount}
      </span>
    );
  }

  renderPlanHeader() {
    let courseType;
    const customVipCourses = [
      'VLMT4',
      'VLMT3',
      'VLMT2',
      'VULMT4',
      'VULMT3',
      'VULMT2',
      'VL4',
    ];
    const customCorpCourses = ['CORPL4', 'CORPL3', 'CORPL2'];
    const customLumpsumCourses = [
      'LMTL2',
      'LMTL3',
      'LMTL4',
      'PREULMTL4',
      'PREULMTL3',
      'PREULMTL2',
      'FL1',
      'FL2',
      'FL3',
      'FL4',
      'RL1',
      'RL2',
      'RL3',
      'RL4',
      'GCC-DIR-RL',
      'GCC-DIR-FL',
      'LRL4',
      'LRL3',
      'LRL2',
      'LFL4',
      'LFL3',
      'LFL2',
      'GCC-DIR-LRL',
      'GCC-DIR-LFL',
      'HTFL3LMV',
      'HTRL3LB',
      'HBRL2LMV',
      'HBFL2LMV',
      'HBFL2HVT',
      'HBRL2HVT',
      'HBFL2LB',
      'HBRL2LB',
      'HLRL2LHL',
      'HTF2LHL',
      'HTR2LHL',
      'HLFL2LHL',
      'HTF3HB',
      'HTFL3HB',
      'HTRL3HB',
      'HTR3HB',
      'HTF3LB',
      'HTR3LB',
      'HTFL3LB',
      'HTRL3LMV',
      'HTR3'
    ];
    const customVIPCourses = ['V2', 'V3', 'V4', 'VG2', 'VG3', 'VG4','VS2', 'VS3', 'VS4'];
    if (this.props.course && this.props.course.courseType) {
      const courseTypeCode: any = this.props.course?.courseType?.code;
      if (this.props.course?.courseType?.isLumpSumCourse) {
        if (this.props.course?.courseType?.isVipCourse) {
          if (this.props?.course?.courseType?.code === 'VLMT4') {
            courseType = 'VIP Limited Lumpsum 40';
          } else if (this.props?.course?.courseType?.code === 'VLMT3') {
            courseType = 'VIP Limited Lumpsum 30';
          } else if (this.props?.course?.courseType?.code === 'VLMT2') {
            courseType = 'VIP Limited Lumpsum 20';
          } else if (this.props?.course?.courseType?.code === 'VLMT1') {
            courseType = 'VIP Limited Lumpsum 10';
          } else if (this.props?.course?.courseType?.code === 'VL4') {
            courseType = 'VIP Normal Lumpsum 40';
          } else if (this.props?.course?.courseType?.code === 'VL3') {
            courseType = 'VIP Normal Lumpsum 30';
          } else if (this.props?.course?.courseType?.code === 'VL2') {
            courseType = 'VIP Normal Lumpsum 20';
          } else if (customVIPCourses?.includes(courseTypeCode)) {
            courseType = this.props.course.courseType.name.en;
          } else {
            courseType = 'VIP Unlimited Lumpsum';
          }
        } else if (customLumpsumCourses?.includes(courseTypeCode)) {
          courseType = this.props.course.courseType.name.en;
        } else {
          courseType = 'VIP Normal Lumpsum';
        }
      } else {
        courseType = this.props.course.courseType.name.en;
      }
    }
    return (
      <>
        <div className="flex justify-between">
          <div
            className="custom-radio whitespace-nowrap"
            onClick={() => {
              if (!this.props.disableSelect) {
                this.props.onSelect(this.props.course);
              }
            }}
          >
            <input
              type="radio"
              name="plan"
              id={courseType}
              value={courseType}
              // onClick={() => setPlanselect("regular")}
              // onChange={() => this.props.onSelect(this.props.course)}
              checked={
                this.props.selectedId === this.props.course.courseTypeId
                  ? true
                  : undefined
              }
            />
            <label htmlFor={courseType} className="planlabel">
              {courseType}
            </label>
          </div>
          <div className="text-right">
            {this.renderPlanHeaderAmount()}
            <p className="text-sm">
              {this.props.course.amount.totalDiscount > 0 &&
                this.renderPlanHeaderOriginalCourseAmount()}
              {this.props.course.amount.totalDiscount > 0 &&
                this.renderPlanHeaderDiscountInfo()}
            </p>
            {this.renderPlanHeaderNote()}
            {this.props.course.courseType.isLumpSumCourse &&
              this.renderLumpSumDisclaimer()}
          </div>
        </div>
        <div className="sm:ltr:pl-[30px] sm:rtl:pr-[30px] md:-mt-3">
          {!this.props.course?.courseType?.isLumpSumCourse &&
            this.getAmountPerClass() && (
              <p className="text-sm">
                AED {this.getAmountPerClass()} /per hour
              </p>
            )}
          <p className="text-[13px] text-muted">
            This course is suggested by your driving license experience and
            Nationality
          </p>
          {this.props.course.courseType.code === 'LMTL2' && (
            <p className="text-[13px] text-muted">
              Any additional will be charge seperately
            </p>
          )}
        </div>
      </>
    );
  }

  // eslint-disable-next-line class-methods-use-this
  renderPlanListItem(
    label: string,
    value: string | number,
    key: string | number
  ) {
    return (
      <div className=" py-2.5 font-medium flex" key={`${key}`}>
        <span className="pt-0.5 ltr:pr-3.5 rtl:pl-3.5 ">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="19"
            viewBox="0 0 18 19"
            fill="white"
          >
            <circle cx="9" cy="9.5" r="9" fill="black" />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M7.67913 12.6193C7.94011 12.8803 8.36323 12.8803 8.62421 12.6193L14.2041 7.03925C14.4651 6.77827 14.4651 6.35515 14.2041 6.09417C13.9431 5.83319 13.52 5.83319 13.259 6.09417L7.67913 11.6742C7.41815 11.9352 7.41815 12.3583 7.67913 12.6193Z"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M4.69622 8.74847C4.9572 8.48749 5.38032 8.48749 5.6413 8.74847L8.47653 11.5837C8.7375 11.8447 8.7375 12.2678 8.47653 12.5288C8.21555 12.7897 7.79243 12.7897 7.53145 12.5288L4.69622 9.69354C4.43524 9.43257 4.43524 9.00944 4.69622 8.74847Z"
            />
          </svg>
        </span>
        <div className="grid grid-cols-10 gap-x-2 flex-grow">
          <div className="md:col-span-3 sm:col-span-4 col-span-12 text-sm lg:text-base">
            {label}
          </div>
          <div className="md:col-span-7 sm:col-span-8 col-span-12 text-muted text-sm">
            : {value}
          </div>
        </div>
      </div>
    );
  }

  renderReadMoreLessButton() {
    return (
      <span
        className="text-sm text-secondary font-medium inline-block cursor-pointer mt-3.5"
        onClick={() => this.setState({ isMore: !this.state.isMore })}
      >
        {this.state.isMore === true ? 'View Less' : 'View More'}
      </span>
    );
  }

  renderInfoList() {
    const { courseType } = this.props.course;
    const infoList = [
      {
        label: 'Week Sequence',
        value:
          courseType.weekSequences && courseType.weekSequences.length
            ? formatMultiLanguageText(courseType.weekSequences[0].name) ||
              'All days'
            : 'All days',
      },
      {
        label: 'Number of hours per week',
        value: `${courseType.noOfHoursPerWeek} hrs`,
      },
    ];

    if (this.getAmountPerClass()) {
      infoList.push({
        label: 'Training fees per hour',
        value: courseType.isLumpSumCourse
          ? 'N/A'
          : `AED ${this.getAmountPerClass()}`,
      });
    }

    infoList.push(
      {
        label: 'Minimum Booking duration',
        value: `${courseType.minimumClassDuration} hr`,
      },
      {
        label: 'Maximum Booking duration',
        value: `${courseType.maximumClassDuration} hr`,
      }
    );

    if (courseType?.code === 'R') {
      infoList.push(
        {
          label: 'Time allowed in the class type',
          value: '08:30 AM - 17:30 PM',
        },
        {
          label: 'Tax exclusive',
          value: 'Eye test/ Medical fees',
        },
        {
          label: 'Course Tax',
          value: 'Price Exclusive',
        }
      );
    }

    if (courseType?.code === 'F') {
      infoList.push(
        {
          label: 'Time allowed in the class type',
          value: '08:30 AM - 17:30 PM, 20:00 PM – 23:00 PM',
        },
        {
          label: 'Tax exclusive',
          value: 'Eye test/ Medical fees',
        },
        {
          label: 'Course Tax',
          value: 'Price Exclusive',
        }
      );
    }

    if (
      courseType?.code === 'RL4' ||
      courseType?.code === 'RL3' ||
      courseType?.code === 'RL2'
    ) {
      infoList.push(
        {
          label: 'Time allowed in the class type',
          value: '08:30AM - 17:30PM',
        },
        {
          label: 'Tax exclusive',
          value: 'Eye test/ Medical fees',
        },
        {
          label: 'Course Tax',
          value: 'Price Exclusive',
        },
        {
          label: 'Additional Charge',
          value: 'Absent classes and test fees are applicable',
        }
      );
    }

    if (
      courseType?.code === 'FL4' ||
      courseType?.code === 'FL3' ||
      courseType?.code === 'FL2'
    ) {
      infoList.push(
        {
          label: 'Time allowed in the class type',
          value: '08:30 AM - 17:30 PM, 20:00 PM – 23:00 PM',
        },
        {
          label: 'Tax exclusive',
          value: 'Simulator, Eye test/medical fees',
        },
        {
          label: 'Course Tax',
          value: 'Price Exclusive',
        },
        {
          label: 'Additional Charge',
          value: 'Absent classes and test fees are applicable',
        },
        {
          label: 'Re-evaluation fees inclusive',
          value: 'Intermediate & Expert',
        },
        {
          label: 'Additional Payments Exclusive',
          value: 'RIS, Early test, LP renewal, File renewal etc',
        },
        {
          label: 'Applicable fees',
          value: 'Absent classes and test fees',
        }
      );
    }
    
    if (
      courseType?.code === 'V4' ||
      courseType?.code === 'V3' ||
      courseType?.code === 'V2'
    ) {
      infoList.push(
        {
          label: 'Time allowed in the class type',
          value: '08:30 AM - 17:30 PM, 20:00 PM – 23:00 PM',
        },
        {
          label: 'Course Tax',
          value: 'Price Exclusive',
        },
        {
          label: 'Additional Charge',
          value: 'Absent classes and test fees are applicable',
        },
        {
          label: 'Training Vehicle',
          value: 'BMW  or Audi',
        },
        {
          label: 'Additional Payments Exclusive',
          value: 'Eye test/ Medical fees',
        },
        {
          label: 'Applicable fees',
          value: 'Absent classes and test fees',
        },
        {
          label: 'Additional payments',
          value: 'Applicable to First driving centre VIP Rate card',
        }
      );
    }

    return (
      // <ul className={`Plan__list ${this.props.isExpanded ? 'Expanded' : ''}`}>
      // this.props.isExpanded && (
      this.state.isMore === true && (
        <div className="pb-1 pt-4 points">
          {infoList.map((info, index) =>
            this.renderPlanListItem(info.label, info.value, index)
          )}
        </div>
      )
    );
  }

  getFullPaymentDiscount(): number {
    return this.props.course?.amount?.fullPaymentDiscount ?? 0;
  }

  renderPlanHeaderAmountWithFullPayDiscount() {
    return (
      <h2 className="md:text-2xl text-lg md:leading-normal font-medium md:font-semibold">
        AED{' '}
        {this.props.course.amount.totalAmount -
          this.props.course.amount.totalDiscount -
          this.getFullPaymentDiscount()}
      </h2>
    );
  }

  renderPlanHeaderOriginalCourseAmountWithFullPayDiscount() {
    return (
      <span className="text-muted line-through">
        AED {this.props.course.amount.totalAmount - this.props.course.amount.totalDiscount}{' '}
      </span>
    );
  }

  renderPlanHeaderDiscountInfoWithFullPayDiscount() {
    return (
      <span className="text-red-500 ltr:ml-auto rtl:mr-auto">
        You save AED{' '}
        {this.props.course.amount.fullPaymentDiscount}
      </span>
    );
  }

  renderAdditionalDiscountHeader() {
    const hasFullPaymentDiscount = this.getFullPaymentDiscount() > 0;
    return (
      <div className="mt-4">
        <p className="text-sm font-medium mb-2">Choose how you'd like to pay</p>
        <div className="grid grid-cols-2 gap-2">
          <div className="bg-slate-50 border rounded-[10px] px-3 py-3">
            <p className="text-[13px] text-muted">Full Payment</p>
            <div className="flex flex-wrap items-baseline gap-x-2 text-sm">
              {this.renderPlanHeaderAmountWithFullPayDiscount()}
              {((this.props.course.amount.totalDiscount > 0 || this.props.course.amount.totalDiscount > 0 ) ||
                hasFullPaymentDiscount) &&
                this.renderPlanHeaderOriginalCourseAmountWithFullPayDiscount()}
              {hasFullPaymentDiscount &&
                this.renderPlanHeaderDiscountInfoWithFullPayDiscount()}
            </div>
          </div>
          {this.props.course.amount.totalDiscount > 0 && 
            <div className="bg-slate-50 border rounded-[10px] px-3 py-3">
              <p className="text-[13px] text-muted">Milestone Payment</p>
              <div className="flex flex-wrap items-baseline gap-x-2 text-sm">
              {this.renderPlanHeaderAmount()}
                {this.props.course.amount.totalDiscount > 0 &&
                  this.renderPlanHeaderOriginalCourseAmount()}
              </div>
            </div>
          }
        </div>
      </div>
    );
  }

  render() {
    return (
      <div
        className={`border rounded-[10px] p-4 md:p-6 mb-5 ${
          this.state.isMore === true ? 'bg-slate-50' : ''
        }`}
      >
        {this.renderPlanHeader()}
        <div className="sm:ltr:pl-8 sm:rtl:pr-8">
          {this.renderInfoList()}
          {this.renderReadMoreLessButton()}
          {(this.props.course?.amount?.fullPaymentDiscount ?? 0) > 0 &&
            this.renderAdditionalDiscountHeader()}
        </div>
      </div>
    );
  }
}

export default CoursePlan;
